import { isPermissionType } from "@p0security/shared/types/permission";
import type {
  Filter,
  IntegrationResourceRule,
} from "@p0security/shared/types/policy/types";
import { Flex, Typography } from "@p0security/ui";
import { AllIntegrationLogos } from "components/Integrations/IntegrationLogo";
import type { IntegrationData } from "components/Integrations/types";
import { capitalize } from "lodash";
import pluralize from "pluralize";

import { ResourceFilterCount } from "./ResourceFilterCount";

type Props = {
  integrationMap: IntegrationData[];
  resource: IntegrationResourceRule;
  resourceFilters: { filter: Filter; filterType: string }[];
};

export const ResourceAccessTypeLabel: React.FC<Props> = ({
  integrationMap,
  resource,
  resourceFilters,
}) => (
  <Flex align="center" gap={12}>
    {isPermissionType(resource.service) &&
      AllIntegrationLogos[resource.service]}
    <Flex vertical gap={2}>
      <Typography.Text>
        {(integrationMap.find((i) => i.key === resource.service)?.label ??
          capitalize(resource.service)) +
          (resource.type === "integration" &&
          resource.accessType &&
          resource.accessType !== "any"
            ? `: ${capitalize(pluralize(resource.accessType))}`
            : "")}
      </Typography.Text>
      {resourceFilters.length > 0 && (
        <ResourceFilterCount resourceFilters={resourceFilters} />
      )}
    </Flex>
  </Flex>
);
